var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "bvModal",
      attrs: { id: "subject_form_modal", "no-close-on-backdrop": true },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-header-buttons-container" }, [
                _c("div", { staticClass: "placeholder" }),
                _c("h2", [_vm._v(_vm._s(_vm.modalTitle))]),
                _c(
                  "button",
                  {
                    staticClass: "close-modal-btn mr-7",
                    attrs: { id: "subject_form_modal_close_btn" },
                    on: {
                      click: function ($event) {
                        return close()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "feather feather-x",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "28",
                          height: "28",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("line", {
                          attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                        }),
                        _c("line", {
                          attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function ({ close }) {
            return [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.footerLeftVisible,
                      expression: "footerLeftVisible",
                    },
                  ],
                  staticClass: "footer-left",
                },
                [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.mode === "edit",
                          expression: "form.mode === 'edit'",
                        },
                      ],
                      staticClass: "bb-btn btn-danger",
                      on: {
                        click: function ($event) {
                          return _vm.deleteSubject()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("subjectFormModal.deleteBtn")) + " "
                      ),
                    ]
                  ),
                ]
              ),
              _c("div", { staticClass: "footer-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "bb-btn btn-outline",
                    on: {
                      click: function ($event) {
                        return close()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("subjectFormModal.closeBtn")) + " "
                    ),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "bb-btn btn-success",
                    on: {
                      click: function ($event) {
                        return _vm.submit()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("subjectFormModal.saveBtn")) + " "
                    ),
                  ]
                ),
              ]),
            ]
          },
        },
      ]),
    },
    [
      _c("div", { staticClass: "modal-body-section" }, [
        _c("div", { staticClass: "modal-inputs-holder" }, [
          _c("div", { staticClass: "form-groups-container" }, [
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("subjectFormModal.subjectNumber.label"))),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.fields.subjectNumber,
                    expression: "form.fields.subjectNumber",
                  },
                ],
                staticClass: "bb-input",
                attrs: { type: "number" },
                domProps: { value: _vm.form.fields.subjectNumber },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.form.fields,
                      "subjectNumber",
                      $event.target.value
                    )
                  },
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.subjectNumber,
                      expression: "form.errors.subjectNumber",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("subjectFormModal.validation.error")) +
                      " "
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("subjectFormModal.courtNumber.label"))),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.fields.courtNumber,
                    expression: "form.fields.courtNumber",
                  },
                ],
                staticClass: "bb-input",
                attrs: { type: "number" },
                domProps: { value: _vm.form.fields.courtNumber },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.form.fields,
                      "courtNumber",
                      $event.target.value
                    )
                  },
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.lastName,
                      expression: "form.errors.lastName",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("subjectFormModal.validation.error")) +
                      " "
                  ),
                ]
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "bb-form-group" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("subjectFormModal.type.label"))),
              ]),
              _c("BBSelect", {
                attrs: { options: _vm.typeOptions },
                model: {
                  value: _vm.form.fields.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.fields, "type", $$v)
                  },
                  expression: "form.fields.type",
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.type,
                      expression: "form.errors.type",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("subjectFormModal.validation.error")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "bb-form-group" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("subjectFormModal.courtName.label"))),
            ]),
            _c(
              "div",
              { staticClass: "birthday-inputs" },
              [
                _c("BBSelect", {
                  attrs: {
                    options: _vm.courtOptions,
                    search: true,
                    searchPlaceholder: _vm.$t(
                      "subjectFormModal.subjectInput.searchPlaceholder"
                    ),
                  },
                  model: {
                    value: _vm.form.fields.courtName,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.fields, "courtName", $$v)
                    },
                    expression: "form.fields.courtName",
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.courtName,
                        expression: "form.errors.courtName",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("subjectFormModal.validation.error")) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "bb-form-group client-select" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("subjectFormModal.clientInput.label"))),
              ]),
              _c("BBSelect", {
                attrs: {
                  options: _vm.clientsAsOptions,
                  search: true,
                  placeholder: _vm.$t(
                    "subjectFormModal.clientInput.placeholder"
                  ),
                  searchPlaceholder: _vm.$t(
                    "subjectFormModal.clientInput.searchPlaceholder"
                  ),
                  noOptionsText: _vm.$t(
                    "subjectFormModal.clientInput.noResultsText"
                  ),
                },
                scopedSlots: _vm._u([
                  {
                    key: "optionItem",
                    fn: function ({ option }) {
                      return [
                        _c("div", { staticClass: "badge-option-container" }, [
                          _c("div", { staticClass: "badge-option" }, [
                            _c("div", { staticClass: "bb-badge" }, [
                              _vm._v(" " + _vm._s(option.initials) + " "),
                            ]),
                            _c("div", { staticClass: "badge-option-text" }, [
                              _c("span", [_vm._v(_vm._s(option.text))]),
                              _c("small", [_vm._v(_vm._s(option.description))]),
                            ]),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.form.fields.clientId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.fields, "clientId", $$v)
                  },
                  expression: "form.fields.clientId",
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.clientId,
                      expression: "form.errors.clientId",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [_vm._v(" " + _vm._s(_vm.form.errors.clientId) + " ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.fields.type == "Litigation",
                  expression: "form.fields.type == 'Litigation'",
                },
              ],
            },
            [
              _c("div", { staticClass: "form-groups-container" }, [
                _c(
                  "div",
                  { staticClass: "bb-form-group" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("subjectFormModal.clientType.label"))
                      ),
                    ]),
                    _c("BBSwitch", {
                      attrs: {
                        label: _vm.$t(
                          "subjectFormModal.clientType.options.defendant"
                        ),
                        frontLabel: _vm.$t(
                          "subjectFormModal.clientType.options.prosecutor"
                        ),
                      },
                      model: {
                        value: _vm.form.fields.clientTypeSwitch,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.fields, "clientTypeSwitch", $$v)
                        },
                        expression: "form.fields.clientTypeSwitch",
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.displayNotes,
                            expression: "form.errors.displayNotes",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("subjectFormModal.validation.error")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "bb-form-group",
                  staticStyle: { "margin-bottom": "-10px !important" },
                },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.$t("subjectFormModal.otherClient.label"))
                    ),
                  ]),
                ]
              ),
              _c("div", { staticClass: "form-groups-container" }, [
                _c("div", { staticClass: "bb-form-group" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("subjectFormModal.otherClient.firstNameInput")
                      )
                    ),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.fields.firstName,
                        expression: "form.fields.firstName",
                      },
                    ],
                    staticClass: "bb-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.form.fields.firstName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.form.fields,
                          "firstName",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.errors.otherClientFirstName,
                          expression: "form.errors.otherClientFirstName",
                        },
                      ],
                      staticClass: "bb-invalid-feedback",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("subjectFormModal.validation.error")) +
                          " "
                      ),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "bb-form-group" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("subjectFormModal.otherClient.lastNameInput")
                      )
                    ),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.fields.lastName,
                        expression: "form.fields.lastName",
                      },
                    ],
                    staticClass: "bb-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.form.fields.lastName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.form.fields,
                          "lastName",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.errors.otherClientLastName,
                          expression: "form.errors.otherClientLastName",
                        },
                      ],
                      staticClass: "bb-invalid-feedback",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("subjectFormModal.validation.error")) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "bb-form-group" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("subjectFormModal.otherClient.mobilePhoneInput")
                    )
                  ),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.fields.phone,
                      expression: "form.fields.phone",
                    },
                  ],
                  staticClass: "bb-input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.fields.phone },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form.fields, "phone", $event.target.value)
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.otherClientPhone,
                        expression: "form.errors.otherClientPhone",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("subjectFormModal.validation.error")) +
                        " "
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }